module.exports = __webpack_public_path__ + "static/media/LivWeb_GraceBeck-3.93ef1380.JPG";